<template>
  <res-dialog :showDialog="showDialog"
              :maxWidth="maxWidth"
              :setWidth="setWidth"
              title=""
              titleClass="resBlue darken-1 white--text"
              :showTitleIcon="false"
              :titleIconSize="17"
              iconColor="white"
              saveButtonText="CONTINUE"
              :saveDisabled="isSaveButtonDisabled"
              cancelButtonText="CANCEL"
              cancelButtonWidth="80"
              :defaultButtonAction="confirm"
              @save="confirm"
              @cancel="cancel">
    <v-card-text>
      <v-row>
        <v-col sm="10">
          The budgets for the below properties <span class="bulk-creation-orange">cannot</span> be created due to the following errors.
        </v-col>
        <v-col sm="2">
          <div class="help-controls step-down" @click="openHelp(null)">
            <span class="help-label">Help</span>
            <v-icon color="var(--v-resBlue-darken1)" class="pb-1">mdi-help-circle</v-icon>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Property
                  </th>
                  <th class="text-left">
                    Error
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in errors" :key="i">
                  <td>{{ item.propertyAbbreviation }}</td>
                  <td><span class="bulk-creation-orange">{{ item.error }}</span></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row class="font-weight-500">
        <v-col>
          <strong class="ml-3">
            Do you want to cancel or continue creating budgets for the remaining properties?
          </strong>
        </v-col>
      </v-row>
    </v-card-text>
  </res-dialog>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';

  export default {
    components: {
      ResDialog
    },
    props: {
      showDialog: {
        type: Boolean
      },
      maxWidth: null,
      setWidth: null,
      bulkCreateErrors: {}
    },
    data() {
      return {
        isSaveButtonDisabled: false
      }
    },
    methods: {
      cancel() {
        this.isSaveButtonDisabled = true;
        this.$emit('cancel', true)
      },
      confirm() {
        this.isSaveButtonDisabled = true;
        this.$emit('confirm', true)
      }
    },
    computed: {
      errors() {
        var errs = [];

        for (var i = 0; i < this.bulkCreateErrors.length; i++) {
          var elementToAdd = { propertyAbbreviation: this.bulkCreateErrors[i].propertyAbbreviation, error: this.bulkCreateErrors[i].error };
          if (this.bulkCreateErrors[i].timesDisplayed > 1) {
            for (var j = 0; j < this.bulkCreateErrors[i].timesDisplayed; j++) {
              errs.push(elementToAdd);
            }
          } else {
            errs.push(elementToAdd);
          }
        }

        return errs;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
    border-top: thin solid rgba(0, 0, 0, 0.12);
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th:last-child {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }

  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:not(.v-data-table__mobile-row) {
    border-left: thin solid rgba(0, 0, 0, 0.12);
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td:last-child {
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:last-child > td {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
  }
  span.bulk-creation-orange {
    color: var(--v-resOrange-darken2);
  }
  </style>
